module.exports = __webpack_public_path__ + "img/mi-tips-and-updates.891007e3.svg";